import { endpoints, host } from '@config/endpoints';
import request from './request';

export const exportMemberMigrationOccupations = async (urlDataAPI: any) => {
    const { exportType, hubIds } = urlDataAPI;
    const { path, method } = endpoints.occupationAndSector.exportMemberMigrationOccupations;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { exportType, hubIds },
            {
                responseType: "blob"
            },
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
